/**
 * @module
 *
 * @todo
 *
 *   - Move into **Nova**
 */
import {GlobalActor, GlobalContext} from '@acng/frontend-relativity';
import {location} from 'nova'

export const ctxSearchParams = GlobalContext(location.searchParams);

export const update = (() => {
  const update_ = GlobalActor(ctxSearchParams);
  let previous = location.search;

  return () => {
    if (location.search != previous) {
      previous = location.search;
      update_(location.searchParams);
    }
  };
})();
